import { render, staticRenderFns } from "./FormRender2.vue?vue&type=template&id=299c2c36&scoped=true&"
import script from "./FormRender2.vue?vue&type=script&lang=js&"
export * from "./FormRender2.vue?vue&type=script&lang=js&"
import style0 from "./FormRender2.vue?vue&type=style&index=0&id=299c2c36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299c2c36",
  null
  
)

export default component.exports